import { useStatsigClient } from '@statsig/react-bindings';

import { GATES } from '@constants';

/**
 * Checks whether the survey translation feature is enabled.
 */
export const useCanUseSurveyTranslation = () => {
  const { client } = useStatsigClient();
  return client.checkGate(GATES.SURVEY_TRANSLATION);
};
